<template>
  <v-container fluid>
    <p>روش تماس</p>
    <v-radio-group
        v-model="radios"
        row
    >
      <v-radio
          label="تماس امن"
          value="secure_call"
      ></v-radio>
      <v-radio
          label="تماس مستقیم"
          value="direct_call"
      ></v-radio>
      <v-radio
          label="غیرفعال"
          value="hide_phone"
      ></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
import {Bus} from "../../../main";

export default {
    name: "callMethod",
    props: {
        editmode: {
            default: ''
        }
    },
    data() {
        return {
            radios: 'secure_call',
        }
    },
    watch: {
        radios: {
            handler: function (val) {
                Bus.$emit('callMethod', val);
            },
            deep: true
        },
        editmode: function (val) {
            if (val !== '') {
                this.radios = val
            }
        }
    }
}
</script>

<style scoped>

</style>